AFRAME.registerComponent('shooting-stars', {
    schema: {
        frequency: { type: 'number', default: 0.005 },
        speed: { type: 'number', default: 50 },
        trailLength: { type: 'number', default: 2 },
        thickness: { type: 'number', default: 0.1 },
        lifetime: { type: 'number', default: 2 }
    },

    init: function () {
        this.meteors = [];
        this.scene = this.el.sceneEl.object3D;
    },

    tick: function (time, delta) {
        if (Math.random() < this.data.frequency) {
            this.spawnMeteor();
        }

        for (let i = this.meteors.length - 1; i >= 0; i--) {
            let meteor = this.meteors[i];
            let deltaSeconds = delta / 1000;
            meteor.position.add(meteor.velocity.clone().multiplyScalar(deltaSeconds));
            meteor.lifetime -= deltaSeconds;

            let trailEnd = meteor.position.clone().sub(
                meteor.velocity.clone().normalize().multiplyScalar(this.data.trailLength)
            );
            meteor.geometry.setFromPoints([meteor.position, trailEnd]);

            let fadeFactor = meteor.lifetime / meteor.maxLifetime;
            meteor.material.opacity = fadeFactor;

            if (meteor.lifetime <= 0 || Math.abs(meteor.position.x) > 100 || Math.abs(meteor.position.z) > 100) {
                this.scene.remove(meteor);
                this.meteors.splice(i, 1);
            }
        }
    },

    spawnMeteor: function () {
        const geometry = new THREE.BufferGeometry();
        const material = new THREE.LineBasicMaterial({
            color: 0xffffff,
            linewidth: this.data.thickness,
            transparent: true,
            opacity: 1
        });

        // Start high in the sky (y: 50 to 70)
        const startPos = new THREE.Vector3(
            Math.random() * 100 - 50, // x: -50 to 50
            Math.random() * 20 + 50,  // y: 50 to 70 (higher range)
            Math.random() * 100 - 50  // z: -50 to 50
        );
        const meteor = new THREE.Line(geometry, material);
        meteor.position.copy(startPos);

        meteor.velocity = new THREE.Vector3(
            Math.random() * 2 - 1,
            -Math.random() * 2 - 1, // Downward trajectory
            Math.random() * 2 - 1
        ).normalize().multiplyScalar(this.data.speed);

        meteor.lifetime = this.data.lifetime * (Math.random() * 0.5 + 0.75);
        meteor.maxLifetime = meteor.lifetime;

        const trailEnd = startPos.clone().sub(
            meteor.velocity.clone().normalize().multiplyScalar(this.data.trailLength)
        );
        meteor.geometry.setFromPoints([startPos, trailEnd]);

        this.scene.add(meteor);
        this.meteors.push(meteor);
    }
});